import { ContentfulEntryType } from './contentful-entry.type';
import { SubjectType } from './subject.type';

export class ExamType extends ContentfulEntryType {
  public get title(): string {
    return this.fields['title'];
  }

  public get subjects(): Array<SubjectType> {
    const entries: ContentfulEntryType[] = this.fields['subjects'];
    let results: Array<SubjectType> = [];
    for (let entry of entries) {
      results.push(new SubjectType(entry));
    }
    return results;
  }

}


